(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('upload3DModelLocalStorageService', upload3DModelLocalStorage);

    upload3DModelLocalStorage.$inject = ['localStorageService'];
    function upload3DModelLocalStorage(localStorageService) {
        
        var service = {
            options: getSetOptions,
            promoMessages: getSetPromoMessages
        };

        return service;

        // -------------------------------------------------------
        function getSetOptions(options) {
            if (angular.isUndefined(options)) {
                return localStorageService.get("Options");
            }

            localStorageService.set("Options", options);
            return angular.undefined;
        }

        function getSetPromoMessages(promoMessages) {
            if (angular.isUndefined(promoMessages)) {
                return localStorageService.get("PromoMessages");
            }

            localStorageService.set("PromoMessages", promoMessages);
            return angular.undefined;
        }
    }
})();